<template>
    <div v-bind="getRootProps()">
        <input v-bind="getInputProps()" >
        <slot name="whenDragging" v-if="isDragActive">
            <div class="mt-4 p-8 cursor-pointer hover:bg-gray-200 bg-gray-100 overflow-hidden rounded-md border border-dashed border-gray-300 text-gray-400 flex flex-row justify-center items-center">
                Drop the files here ...
            </div>
        </slot>
        <slot :open="open" v-else>
            Drag 'n' drop some files here, or click to select files
        </slot>
    </div>
</template>

<script>
import { useDropzone } from 'vue3-dropzone'

export default {
    props: {
        accept: {
            type: Array,
            default: ['image/png', 'image/jpg', 'image/jpeg']
        },
        multiple: {
            type: Number,
            default: null,
        },
        maxFiles: {
          type: Number,
          default: 0,
        },
        onDrop: {
            type: Function,
        },
        noClick: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup(props) {
        function onDrop(acceptFiles, rejectReasons) {
            console.log(acceptFiles)
            console.log(rejectReasons)
        }

        const { getRootProps, getInputProps, ...rest } = useDropzone({
            onDrop: props.onDrop ?? onDrop,
            noClick: props.noClick,
            maxFiles: props.maxFiles,
            multiple: props.multiple,
            accept: props.accept,
            disabled: props.disabled,
        })

        return {
            getRootProps,
            getInputProps,
            ...rest
        }
    }
}
</script>
